import Cookie from 'js-cookie';

const GeoService = {
    cache: {},

    /**
     * Получаем город пользователя по GEO.
     *
     * @returns {Promise<Object<{
     *      value: string,
     *      label: string,
     * }>>}
     */
    getUserCityByGeo: () => {

        const airportCookie = Cookie.get('airport');
        const countryCookie = Cookie.get('country');

        return {
            airportCode: !airportCookie ? 'DME' : airportCookie,
            countryISOCodeValue: !countryCookie ? 'RU' : countryCookie
        };

    },
};

export default GeoService;
